/**
 * Shared UI module for SMG
 */
(function() {
  angular.module('smg.ui.animation', [
    'ngAnimate'
  ])

  .directive('smgNoAnimation', [
    '$animate', function($animate) {
      return function(scope, element) {
        $animate.enabled(element, false);
      };
    }
  ])

  .animation('.animate-slide', [
    'jQuery', function(jQuery) {
      var enter, leave;

      enter = function(element, done) {
        jQuery(element)
          .hide()
          .slideDown(100, done);
      };
      leave = function(element, done) {
        jQuery(element).slideUp(100, done);
      };

      return {
        enter: enter,
        leave: leave,
        removeClass: function(element, className, done) {
          if (className === 'ng-hide') {
            enter(element, done);
          } else {
            done();
          }
        },
        addClass: function(element, className, done) {
          if (className === 'ng-hide') {
            leave(element, done);
          } else {
            done();
          }
        }
      };
    }
  ]);
}).call(this);
